import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
export default function SignupCard(props) {
  const { t } = useTranslation();
  return (
    <div className="ui-card relative text-center p-4 xl:p-6">
      <h2>{t("CustomerSignUp-title")}</h2>
      <p className="text-sm mb-6">{t("CustomerSignUp-subtitle")}</p>
      <div className="text-left mb-6">
        <ul className="text-xs">
          <li className="flex items-center mb-3 font-semibold">
            <svg
              className="ui-icon w-4 h-4 text-theme-action mr-2"
              focusable="false"
              aria-hidden="true"
              role="presentation"
            >
              <use href="#ui-icon-payment"></use>
            </svg>
            {t("CustomerSignUp-listitem")}
          </li>
          <li className="flex items-center mb-3 font-semibold">
            <svg
              className="ui-icon w-4 h-4 text-theme-action mr-2"
              focusable="false"
              aria-hidden="true"
              role="presentation"
            >
              <use href="#ui-icon-document-multiple"></use>
            </svg>
            {t("CustomerSignUp-listitem-2")}
          </li>
          <li className="flex items-center mb-3 font-semibold">
            <svg
              className="ui-icon w-4 h-4 text-theme-action mr-2"
              focusable="false"
              aria-hidden="true"
              role="presentation"
            >
              <use href="#ui-icon-alert"></use>
            </svg>
            {t("CustomerSignUp-listitem-4")}
          </li>
        </ul>
      </div>
      <Link
        to="/register"
        className="ui-btn-primary min-w-[144px] mb-10 mx-auto"
      >
        {t("CustomerSignUp-button")}
      </Link>
    </div>
  );
}
